import { cn } from '@/lib/utils';
import { ActiveOrInactiveIcon } from './active-or-inactive-icon';
import type { ComparisonTableProps } from '../types';

const ComparisonTableDesktop = ({ comparisonTable }: ComparisonTableProps) => {
  return (
    <div className="">
      <div className="w-full overflow-hidden rounded-[10px]">
        {/* HEADING */}
        <div>
          <div className="w-full gap-[2px] flex">
            {comparisonTable.tableHeading.map(
              (heading: string, index: number) => {
                return (
                  <div
                    key={index}
                    className={cn(
                      `text-white font-nunito700 text-base py-[15px] px-5 text-center bg-black w-[20.686%]`,
                      {
                        'w-[59.5%] text-left': index === 0,
                        'gradient-column text-black': index === 2,
                      }
                    )}
                  >
                    {heading}
                  </div>
                );
              }
            )}
          </div>
        </div>

        {/* BODY */}
        <div className="text-black flex flex-col gap-[2px] mt-[2px]">
          {comparisonTable.data.map((row, index) => {
            return (
              <div key={index} className="flex gap-[2px]">
                {/* First Col */}
                <div className="flex basis-[20.4%] flex-col justify-center px-5 py-[10px] gap-1 bg-light-grey-200 text-black">
                  <h4 className="text-base whitespace-pre-line font-nunito700">
                    {row.title}
                  </h4>
                  <h5 className="text-sm">{row.subtitle} </h5>
                </div>

                <div className="flex flex-col basis-[79.4%] gap-[2px]">
                  {row.content.map((row, index) => {
                    return (
                      <div
                        key={`${index}-body-content`}
                        className="flex flex-row w-full h-full gap-[2px]"
                      >
                        {/* Second Col */}
                        <div className="h-full flex w-[48.3%] flex-col bg-light-grey-200">
                          <div className="py-[15px] px-5 text-sm flex items-center h-full">
                            {row.text}
                          </div>
                        </div>
                        {/* Third Col */}
                        <div className="flex flex-col h-full bg-light-grey-200 w-[25.9%]">
                          <div className="px-5 py-[15px] h-full flex items-center">
                            <ActiveOrInactiveIcon isActive={row.version_1} />
                          </div>
                        </div>
                        {/* Fourth Col */}
                        <div className="flex flex-col h-full bg-light-grey-200 w-[25.9%]">
                          <div className="px-5 py-[15px] flex h-full items-center">
                            <ActiveOrInactiveIcon isActive={row.version_2} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { ComparisonTableDesktop };
